import React from 'react';
import { CDrawerSection } from './styles';
import useExStore from '@/hooks/trade/exStore';

const CDrawer = ({ renderDrawer, displayDrawer }) => {
  const { setIsOpen, isOpen: exIsOpen } = useExStore();

  return (
    <div
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
    >
      {displayDrawer && (
        <CDrawerSection display={''}>{renderDrawer()}</CDrawerSection>
      )}
    </div>
  );
};

export default React.memo(CDrawer);
